import React from 'react';
import LoginForm from './login-form';
import enhance from './enhance';
import './login.css';

class Login extends React.Component {
  componentDidMount() {
    this.props.listenAuth();
  }

  render() {
    return (
      <div className="login">
        <LoginForm />
      </div>
    );
  }
}

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/components/login/index.js